import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-bottombar',
    templateUrl: './bottombar.component.html',
    styleUrls: ['./bottombar.component.scss'],
    standalone: false
})
export class BottombarComponent implements OnInit {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
